import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import ImageCarousel from "./ImageCarousel";

const Landing = () => {
  const navigate = useNavigate();
  const heroRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: heroRef,
    offset: ["start start", "end start"],
  });
  const imageY = useTransform(scrollYProgress, [0, 1], [0, 140]);
  const contentY = useTransform(scrollYProgress, [0, 1], [0, 70]);
  const contentOpacity = useTransform(scrollYProgress, [0, 0.75], [1, 0]);

  return (
    <main ref={heroRef} className="hero-shell relative h-screen min-h-[680px] overflow-hidden">
      <motion.div className="absolute inset-0 scale-[1.04]" style={{ y: imageY }}>
        <ImageCarousel />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#14274A]/45 via-[#14274A]/35 to-[#14274A]/90" />
      <div className="absolute inset-0 hero-grain" />

      <motion.div
        style={{ y: contentY, opacity: contentOpacity }}
        className="absolute inset-0 z-[1] flex items-center justify-center px-6 pt-20 text-center"
      >
        <div className="max-w-5xl">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="mb-5 font-montserrat text-[11px] font-semibold uppercase tracking-[0.38em] text-[#E0B973] sm:text-xs"
          >
            Gawadrong · Samtse · Bhutan
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 35 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.25, ease: [0.16, 1, 0.3, 1] }}
            className="font-garamond text-6xl font-medium leading-[0.86] tracking-[-0.035em] text-white sm:text-7xl md:text-8xl lg:text-[8.5rem]"
          >
            Zeebar <span className="italic text-[#E0B973]">Resort</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 25 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.45 }}
            className="mx-auto mt-7 max-w-xl font-montserrat text-sm font-light leading-7 text-white/85 sm:text-base"
          >
            Thoughtful Bhutanese hospitality, quiet mountain air and modern comfort—made for the moments you want to remember.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row"
          >
            <button className="gold-button" onClick={() => navigate("/booking")}>
              Book your stay
            </button>
            <button className="outline-button" onClick={() => navigate("/rooms")}>
              Explore rooms
            </button>
          </motion.div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.1 }}
        className="absolute bottom-7 left-1/2 z-[2] -translate-x-1/2 text-center text-white/70"
      >
        <span className="font-montserrat text-[9px] uppercase tracking-[0.3em]">Discover</span>
        <div className="mx-auto mt-3 h-12 w-px overflow-hidden bg-white/25">
          <span className="block h-5 w-px animate-scroll-line bg-[#E0B973]" />
        </div>
      </motion.div>
    </main>
  );
};

export default Landing;
